/* eslint-disable */

import { image } from "d3"

const functionalities = {
    Mantenimiento: 'Global',
    Info: 'Información',
}

functionalities.vida = {
    EECC: 'Estado de cuenta',
    COMPROBANTES: 'Comprobantes electrónicos',
    DESCARGA_POLIZA: 'Póliza electrónica vida',
    CVC: 'Cambio de vía de cobro',
    CUOTAS_PENDIENTES: 'Cuotas pendientes',
    PAGO_CUOTAS: 'Pago de cuotas',
    PAGO_EFECTIVO: 'Pago efectivo',
    VIADP: 'Anulación de póliza',
    VIEEF: 'Endoso a entidad financiera',
    VICFP: 'Cambio Frecuencia de Pago',
    VICCM: 'Cuota comodín',
    VILE: 'Liberación de endoso',
    VIMDB: 'Modificación de beneficiarios',
    SEGUIMIENTO: 'Seguimiento de solicitudes',
    VIRCA: 'Eliminación de cobertura'
}

functionalities.rentas = {
    PRESTAMOS: 'Préstamos',
    PREPAGOS: 'Prepagos',
    DESCARGA_POLIZA: 'Póliza electrónica rentas',
    BOLETAS: 'Boletas rentas',
    CONSTANCIA_JUBILACION: 'Constancia de jubilación',
    CRONOGRAMA_PRESTAMO: 'Cronograma préstamos'
}

functionalities.masivos = {
    COMPROBANTES: 'Comprobantes electrónicos',
    DESCARGA_POLIZA: 'Póliza electrónica vehicular'
}

functionalities.requirements = {
    'Modificación de Beneficiarios': 'Modificación de beneficiarios',
}

functionalities.isAvailable = (key, functions, component, productName = null) => {
    const { mostrar, titulo, mensaje, imagen, bloqueado = [] } = functions[key] || {}
    const productoBloqueado = productName && bloqueado.some(p => p.toLowerCase() === productName.toLowerCase())
    if (functions[key] && (!mostrar || productoBloqueado)) {
        component.$swal({
            title: titulo,
            html: mensaje,
            imageUrl: imagen || require('./../assets/characters/informa.svg'),
            confirmButtonText: 'Entendido'
        }).then((result) => {
        }).catch(() => {
        })
        return false
    }
    return !functions[key] || !!mostrar
}

functionalities.isAvailableSilent = (key, functions, productName = null) => {
    const { mostrar, bloqueado = [] } = functions[key] || {}
    const productoBloqueado = productName && bloqueado.some(p => p.toLowerCase() === productName.toLowerCase())
    return !functions[key] || (mostrar && !productoBloqueado)
}

functionalities.areAvailable = (keys, functions, component, productName = null) => {
    const list = keys.map(key => functions[key])
    const notAvailable = list.filter(f => {
        if (!f) return false
        const productoBloqueado = productName && (f.bloqueado || []).some(p => p.toLowerCase() === productName.toLowerCase())
        return !f.mostrar || productoBloqueado
    })
    let anyAvailable = true;
    try {
        if (notAvailable.length === keys.length) {
            anyAvailable = false
            component.$swal({
                title: notAvailable[0].titulo,
                html: notAvailable[0].mensaje,
                imageUrl: notAvailable[0].imagen || require('@/assets/characters/oops.svg'),
                confirmButtonText: 'Entendido'
            }).then((result) => {

            }).catch(() => {

            })
        }
    } catch (error) {
        anyAvailable = false
    }
    return anyAvailable
}

export default functionalities



// WEBPACK FOOTER //
// ./src/interfaces/functionalities.js